<template>
  <figure class="image" :style="style">
    <img
      :class="{ 'is-rounded': round }"
      :alt="account.name"
      :src="primary"
      @error="useFallback"
    />
  </figure>
</template>

<style lang="scss" scoped>
img {
  max-height: none !important;
}
</style>

<script>
export default {
  data () {
    return {}
  },

  fallback: '/static/fallbacks/avatar_600x600.png',
  cdnUrl: process.env.S3_CDN_URL,

  props: {
    account: {
      type: Object,
      required: true
    },

    round: Boolean,

    size: {
      type: Number,
      required: false,
      default: 32
    }
  },

  computed: {
    style () {
      const { size } = this

      return size
        ? { height: `${size}px`, width: '100%', 'max-width': `${size}px` }
        : {}
    },

    primary () {
      const { primary } = this.account.avatars

      if (!primary) {
        return this.$options.fallback
      }

      return `${this.cdnUrl}${primary}`
    }
  },

  methods: {
    useFallback () {
      if (this.primary === this.$options.fallback) {
        return
      }

      const img = this.$el.querySelector('img')
      img.src = this.$options.fallback
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/taskflex/users/components/Avatar.vue